module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo9-5e48f7df4e9d2988ffc821c01cfedbcd.jpg";